module.exports = __webpack_public_path__ + "img/parter-avatar2.7917efbd.png";